<template>
    <v-layout justify-center>
    <v-card>
      <!--タイトル-->
          <v-card-title class="head title-center">
        {{ title }}
        <!--タイトル横アイコン-->
        <v-icon
        color="black"
        class="ml-2 mt-1">
          {{ icon }}
        </v-icon>
      </v-card-title>

    <!--概要-->
    <Summary></Summary>
    <!--ポリシー文章-->
    <Poricy></Poricy>
    <!--お問い合わせ-->
    <contact></contact>
    </v-card>
    </v-layout>
</template>

<style>
.title-center{
  justify-content: center;
}
</style>

<script>
import Summary from './Summary'
import Poricy from './Poricy'
import contact from '../contact'

export default {
  data () {
    return {
      // タイトル
      title: '個人情報保護方針',
      // タイトル横のアイコン
      icon: 'mdi-lock-check-outline'
    }
  },
  components: {
    Summary,
    Poricy,
    contact
  }
}
</script>
